import Storage from '@/storage/Storage';

export default {
	// Before new Vue is called: good place to define some routes or vuex modules
	async beforeCreate(context) {

		let [ theme, token, user, account ] = await Promise.all([
			Storage.get('theme', context.req),
			Storage.get('token', context.req),
			Storage.get('user', context.req),
			Storage.get('account', context.req),
		]);

		theme = theme || 'dark';
		token = token || null;
		user = user || {};
		account = account || {};

		context.store.dispatch('updateTheme', { theme });

		// If we have a token we can log the user in.
		if (user && user.id) {
			context.store.dispatch('login', { account_id: account.id || user.last_account_used, user });
			await context.store.dispatch('syncAccountData');
		}
	},
};
